function setStickyTableOffset(stickyTblElem) {
  const tblHeight = stickyTblElem.offsetHeight;
  stickyTblElem.parentElement.style.marginTop = '-' + (tblHeight + 8) + 'px';
}

// once the discount table is created in the first form, clone it to the second, and to sticky
function cloneDiscountTable() {
  const observerCallback = function(mutationListArr, observerObj) {
    if ('money-template' == mutationListArr[0].target.classList[0]) {
      observerObj.disconnect();
      if (mutationListArr[0].target.innerHTML) {
        const secondFormElem = document.getElementById('prodinfo2').getElementsByTagName('form')[0];
        secondFormElem.prepend(mutationListArr[0].target.cloneNode(true));
        const stickyTblElem = document.getElementsByClassName('stickyadd__tablewrap')[0];
        stickyTblElem.prepend(mutationListArr[0].target.cloneNode(true));
        setStickyTableOffset(stickyTblElem);
        stickyAddToCartOptionsBtn();
      }
    }
  };
  const observerObj = new MutationObserver(observerCallback);
  observerObj.observe(document.getElementById('prodinfo'), {childList: true, subtree: true});
}

function showStickyAddToCart() {
  let headerInView = true;
  let cartBtn1InView = true;
  let cartBtn2InView = true;
  let prodinfo2ElemBtn = document.querySelector('#prodinfo2 .btn');
  if (null == prodinfo2ElemBtn) {
    cartBtn2InView = false;
  }
  function onIntersection(entriesArr) {
    for (let i = 0; entriesArr.length > i; i++) {
      if ('header' == entriesArr[i].target.id) {
        if (entriesArr[i].isIntersecting) {
          headerInView = true;
        } else {
          headerInView = false;
        }
      }
      if ('prodinfo' == entriesArr[i].target.parentElement.parentElement.parentElement.id) {
          if (entriesArr[i].isIntersecting) {
          cartBtn1InView = true;
        } else {
          cartBtn1InView = false;
        }
      }
      if ('prodinfo2' == entriesArr[i].target.parentElement.parentElement.parentElement.id) {
        if (entriesArr[i].isIntersecting) {
          cartBtn2InView = true;
        } else {
          cartBtn2InView = false;
        }
      }
    }
    if (!headerInView && !cartBtn1InView && !cartBtn2InView) {
      document.body.classList.add('stickyaddactive');
    } else if (headerInView || cartBtn1InView || cartBtn2InView) {
      document.body.classList.remove('stickyaddactive');
      document.body.classList.remove('stickyaddtable');
    }
  }
  let obsOptObj = {
    threshold: [0, 1]
  };
  let observerObj = new IntersectionObserver(onIntersection, obsOptObj);
  observerObj.observe(document.querySelector('#header'));
  observerObj.observe(document.querySelector('#prodinfo .btn'));
  if (null != prodinfo2ElemBtn) {
    observerObj.observe(document.querySelector('#prodinfo2 .btn'));
  }
}

function stickyAddToCartOptionsBtn() {
  let btnElem = document.getElementsByClassName('js-stickyoptions')[0];
  btnElem.style.display = 'block';
  btnElem.addEventListener('click', function() {
    document.body.classList.toggle('stickyaddtable');
    eventFire('sticky_options_btn', 'click');
  });
}

// delay transition because otherwise it animates hiding the table on load
function enableStickyTransition() {
  setTimeout(function() {
    const stickyElem = document.getElementsByClassName('stickyadd')[0];
    stickyElem.style.transition = 'all .2s';
  }, 1000);
}

cloneDiscountTable();
showStickyAddToCart();
enableStickyTransition();

function priceStringToFloat(priceStr) {
  return parseFloat(priceStr.replace(/[^0-9.]/g, '')).toFixed(2);
}

function updateProductPrice(newPriceFloat) {
  if (isNaN(newPriceFloat)) {
    return;
  }
  const productPriceElem = document.querySelector('.prodinfo__price__main');
  const productCompareAtPriceElem = document.querySelector('.prodinfo__price__compare');
  const productPriceSavingsElem = document.querySelector('.prodinfo__price__savings');
  const currencySymbol = productPriceElem.textContent.charAt(0);
  productPriceElem.textContent = currencySymbol + newPriceFloat;
  if (null != productCompareAtPriceElem && null != productPriceSavingsElem) {
    const origPriceFloat = priceStringToFloat(productCompareAtPriceElem.textContent);
    productPriceSavingsElem.textContent = 'You save ' + currencySymbol + (origPriceFloat - newPriceFloat).toFixed(2);
  }
}

function subscriptionOptionChanged(subscriptionRadioElem) {
  const subscriptionPriceFloat = priceStringToFloat(subscriptionRadioElem.dataset.variantPrice);
  updateProductPrice(subscriptionPriceFloat);
  if ('selling_plan' == subscriptionRadioElem.dataset.radioType) {
  }
}

function watchSubscriptionOptions() {
  const subscriptionRadioElems = document.querySelectorAll('.shopify_subscriptions_app_container input[type="radio"]');
  subscriptionRadioElems.forEach(function(subscriptionRadioElem) {
    subscriptionRadioElem.addEventListener('change', function() {
      subscriptionOptionChanged(subscriptionRadioElem);
    });
  });
}

const subscriptionOptionsContainerElem = document.querySelector('.shopify_subscriptions_app_container');
if (null != subscriptionOptionsContainerElem) {
  watchSubscriptionOptions();
}
